module.exports = __webpack_public_path__ + "img/jl-icon_2.6bf73b8e.png";